import React, { useEffect, useState } from 'react';
import { Container, Row, Col, Image, Button } from 'react-bootstrap';
import './AddLocalStories.css';
import NeighbourSidebar from "../../NeighbourSidebar";
import Header from "../../NeighbourHeaderAfterLogin";
import Footer from "../../FooterAfterLogin";
import Form from 'react-bootstrap/Form';
import { Link,useNavigate } from 'react-router-dom';
import {validatelocalstories} from '../../../Utils/validate';

const AddLocalStories = () => {
    const navigate = useNavigate();

    const [inputs,setInputs] = useState({story_title:'',question:'',anonymous:0,article:''});

    const [errors,setErrors] = useState({});

    useEffect(() => {
        document.title = `Add Local Stories | Local Bells`;
        document.getElementById('bodywrap').className = 'neaddlocalstories';
    }, []);

    // State to toggle sidebar visibility
    const [isSidebarVisible, setIsSidebarVisible] = useState(false);

    // Function to toggle sidebar visibility
    const toggleSidebar = () => {
        setIsSidebarVisible((prev) => !prev);
    };

    const [images, setImages] = useState([]);

    // Handle files dropped or selected
    const handleFiles = (files) => {
        const imageFiles = Array.from(files).filter(file => file.type.startsWith('image/'));
        const newImages = imageFiles.map(file => ({
            file,
            url: URL.createObjectURL(file),
        }));
        setImages(prev => [...prev, ...newImages]);
    };

    // Handle drag events
    const handleDrop = (e) => {
        e.preventDefault();
        e.stopPropagation();
        const files = e.dataTransfer.files;
        handleFiles(files);
    };

    const handleDelete = (urlToRemove) => {
        setImages(prev => {
            const updated = prev.filter(img => img.url !== urlToRemove);
            URL.revokeObjectURL(urlToRemove); // Clean up memory
            return updated;
        });
    };

    const handleInputChangeimg = (e) => {
        handleFiles(e.target.files);
    };
    /* Start Value set */
    const handleInputChange = (event) => {
      event.persist();
      setInputs(inputs => ({...inputs, [event.target.name]: event.target.value}));       
    }
    const handleCheckboxChange = (event) => {
         var anonymous_lbl='anonymous';
         setInputs(inputs => ({...inputs, [anonymous_lbl]: event.target.checked}));
    }
    /* End Value set */
    const handleSubmit = (e) => {
        e.preventDefault();
        const validationErrors = validatelocalstories(inputs,images);
         const noErrors = Object.keys(validationErrors).length === 0;
            setErrors({});
            setErrors(validationErrors);
            if(noErrors){
                navigate('/neighbour/local-stories');
            }
    }; 

    return (
        <>
            <section className="main-cont-box">
                <Container>
                    <Row>
                        <NeighbourSidebar isVisible={isSidebarVisible} setIsVisible={setIsSidebarVisible} />
                        <Col md={12} lg={9} xl={9} xxl={10} className='main-cont-box-right'>
                            <Header toggleSidebar={toggleSidebar} />
                            <div className='nei-cont'>
                                <Row>
                                    <Col md={8} lg={8} xl={6}>

                                        <div className='white-box alc-box'>
                                            
                                            <div className="d-flex align-items-start justify-content-between gap-3">
                                               <h3>Local Stories</h3>
                                                <Link to="#" onClick={() => navigate(-1)} className='cross-up'>
                                                    <Image src={process.env.REACT_APP_BASE_URL + 'assets/images/cross.webp'} className="img-fluid crosy" alt="wp" />
                                                </Link>
                                            </div>
                                            <h6>Share stares about your area, like historic places, unique geography local heroes, or important events</h6>
                                            <Form onSubmit={handleSubmit}>
                                                <Form.Group className="mb-3 mt-3">
                                                    <Form.Label className='d-none'>Story Title</Form.Label>
                                                    <Form.Control type="text" placeholder="Story Title" name="story_title" onChange={handleInputChange} value={inputs.story_title} />
                                                    {errors.story_title && (<p className="text-danger">{errors.story_title}</p>)}
                                                </Form.Group>
                                                <div className=''>
                                                    {/* Dropzone */}
                                                    <div
                                                        onDrop={handleDrop}
                                                        onDragOver={(e) => e.preventDefault()}
                                                        onDragEnter={(e) => e.preventDefault()}
                                                        className='gen-upload'

                                                    >
                                                        <input
                                                            type="file"
                                                            multiple
                                                            accept="image/*"
                                                            onChange={handleInputChangeimg}
                                                            id="fileInput"
                                                        />
                                                        <label htmlFor="fileInput">
                                                            <Image src={process.env.REACT_APP_BASE_URL + 'assets/images/uploadicn.webp'} className="img-fluid" alt="uploadicn" />
                                                            <div>
                                                                <h6>Upload Image</h6>
                                                                <h6><span className='fw-600'>420 X 270</span> px</h6>
                                                            </div>
                                                        </label>
                                                    </div>
                                                    {errors.images && (<p className="text-danger">{errors.images}</p>)}
                                                    {/* Previews */}
                                                    <div className='gen-upload-preview'>
                                                        {images.map((img, index) => (
                                                            <div key={index} >
                                                                <img
                                                                    src={img.url}
                                                                    alt="preview"
                                                                />
                                                                <button
                                                                    onClick={() => handleDelete(img.url)}
                                                                    type='button'
                                                                >
                                                                    &times;
                                                                </button>
                                                            </div>
                                                        ))}
                                                    </div>
                                                </div>
                                                <Form.Group className="mb-3">
                                                    <Form.Label className='d-none'>Type your Question here</Form.Label>
                                                    <Form.Control as="textarea" rows={4} placeholder='Type your Question here' name="question" onChange={handleInputChange} value={inputs.question} />
                                                    {errors.question && (<p className="text-danger">{errors.question}</p>)}
                                                </Form.Group>
                                                <div className='or-box'>
                                                    <h6>or</h6>
                                                </div>
                                                <div className='gen-switch-box'>
                                                    <div className=''>
                                                        <h6>Submit Anonymous</h6>
                                                        <Form.Check
                                                            type="switch"
                                                            id="subano"
                                                            name="anonymous"
                                                            value="1" checked={inputs.anonymous} onChange={handleCheckboxChange}
                                                        />
                                                    </div>
                                                </div>
                                                <Form.Group className="mb-3">
                                                    <Form.Label className='d-none'>Name to be displayed for this Article</Form.Label>
                                                    <Form.Control type="text" placeholder="Name to be displayed for this Article" name="article" onChange={handleInputChange} value={inputs.article}  />
                                                    {errors.article && (<p className="text-danger">{errors.article}</p>)}
                                                </Form.Group>
                                                <Button type="submit" className='blue-btn'>submit story</Button>
                                            </Form>
                                        </div>

                                        <div className='red-note'>
                                            <h6>Terms and conditions: Users must follow respectful communication guidelines. Hate speech, harassment, and misinformation are prohibited, and may result in content removal or account suspension</h6>
                                        </div>
                                    </Col>
                                </Row>
                                <div className='footer-main footer'>
                                    <Footer />                                
                                </div>                                  
                            </div>
                        </Col>
                    </Row>
                </Container>
            </section>
        </>
    )
}

export default AddLocalStories;


